module.exports = __webpack_public_path__ + "media/images/temp-indicator-muted-1-5f36ba242ef261ab96c9a13458003d4a.svg";